exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col[data-v-97b78ba4]{\n    padding-right: 0;\n    padding-left:0;\n}\n.submit-form-container[data-v-97b78ba4] {\n    margin-top: 12px;\n}\n.submit-button[data-v-97b78ba4] {\n    margin-top: 12px;\n    color: #fff;\n    background: #25d366;\n    width: 180px;\n    border: none;\n}\n\n", ""]);

// exports
